import React from "react"
import "./CancelOrder.css"

export default function({ cancelOrder, cancelling }) {
  return (
    <div className="CancelOrder">
      <p>Do you wish to cancel this order?</p>
      <button className="black" type="button" onClick={cancelOrder}>
        {cancelling ? "Cancelling" : "Cancel order"}
      </button>
    </div>
  )
}
